import React, { useEffect, useState } from "react";
import Layout from "components/yenimahalle/Layout.js";
import BasicHeader from "components/yenimahalle/BasicHeader";
import RoutingItems from "components/yenimahalle/RoutingItems";
import PortalApi from "api/PortalApi";
import { ServiceListItem } from "models/Response/Portal";
import { useParams } from "react-router-dom";

type ServiceCard = {
  id: number;
  imageSrc: string;
  title: string;
  link: string;
  openInNewWindow: boolean;
};

const Services: React.FC = () => {
  const { categoryName, categoryID } = useParams<{ categoryName: string; categoryID: string }>();

  const [serviceCards, setServiceCards] = useState<ServiceCard[]>([]);
  const [serviceHeader, setServiceHeader] = useState<string>("");

  useEffect(() => {
    const fetchData = async () => {
      const response = await PortalApi.getServiceList(Number(categoryID));
      if (response && response.serviceList) {
        setServiceHeader(response.serviceHeader);
        const mappedItems = response.serviceList.map((item: ServiceListItem) => ({
          id: item.seriviceId,
          imageSrc: item.imageUrl,
          title: item.header,
          link: item.redirectUrl,
          openInNewWindow: item.openInNewWindow,
        }));
        setServiceCards(mappedItems);
      }
    };

    fetchData();
  }, []);

  return (
    <Layout>
      <BasicHeader headingLine1="" headingLine2={serviceHeader} />
      <RoutingItems cards={serviceCards} />
    </Layout>
  );
};

export default Services;
